import { api } from './api';

export interface Strategy {
  id: string;
  brief_id: string;
  user_id: string;
  module_1_problem: any;
  module_2_insight: any;
  module_3_creative_direction: any;
  module_4_activating_truth: any;
  module_5_integration: any;
  module_6_actionables: any;
  module_x_decision?: any;
  module_y_inputs?: any;
  module_z_diagnostic?: any;
  module_6b_actionables?: any;
  current_module: number;
  status: string;
  project_name?: string;
  created_at: string;
  updated_at: string;
}

export const strategyService = {
  async list(clientId?: string): Promise<Strategy[]> {
    const url = clientId ? `/strategies?client_id=${clientId}` : '/strategies';
    const response = await api.get(url);
    return response.data;
  },

  async getById(id: string): Promise<Strategy> {
    const response = await api.get(`/strategies/${id}`);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/strategies/${id}`);
  },
};
